import { render } from "./TaxSummary.vue?vue&type=template&id=1ae15fcb&scoped=true"
import script from "./TaxSummary.vue?vue&type=script&lang=js"
export * from "./TaxSummary.vue?vue&type=script&lang=js"

import "./TaxSummary.vue?vue&type=style&index=0&id=1ae15fcb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae15fcb"]])

export default __exports__